import { useState } from "react";
import { CATEGORIES, PRICING, discountPct, money } from "@/lib/booking";

function Block({ title, text }) {
    if (!text) return null;
    return (
        <div>
            <h3 className="font-mono2 text-[10px] uppercase tracking-[0.2em] text-neon-cyan">{title}</h3>
            <p className="mt-2 whitespace-pre-line text-sm leading-relaxed text-dim">{text}</p>
        </div>
    );
}

export function ExperienceInfo({ tour }) {
    const images = [tour.image_url, ...(Array.isArray(tour.gallery) ? tour.gallery : [])].filter(Boolean);
    const [main, setMain] = useState(0);
    const price = tour.promo_price ?? tour.price;
    const pct = discountPct(tour.price, tour.promo_price);
    return (
        <section className="mt-8 grid gap-8 lg:grid-cols-[1.2fr_1fr]" data-testid="experience-info">
            <div>
                {images[main] && <img src={images[main]} alt={tour.image_alt || tour.title} className="h-72 w-full rounded-[2rem] object-cover sm:h-96" />}
                {images.length > 1 && <div className="mt-3 flex gap-2 overflow-x-auto">
                    {images.map((src, i) => (
                        <button key={src + i} type="button" onClick={() => setMain(i)} data-testid={`gallery-thumb-${i}`}
                            className={`h-16 w-20 shrink-0 overflow-hidden rounded-xl border ${i === main ? "border-neon-cyan" : "border-transparent"}`}>
                            <img src={src} alt="" loading="lazy" className="h-full w-full object-cover" />
                        </button>
                    ))}
                </div>}
            </div>
            <div className="space-y-5">
                <p className="font-mono2 text-[10px] uppercase tracking-[0.25em] text-neon-cyan">{CATEGORIES[tour.category] || tour.tag}</p>
                <h1 className="font-display text-3xl font-black uppercase sm:text-5xl" data-testid="experience-title">{tour.title}</h1>
                <p className="leading-relaxed text-dim">{tour.description}</p>
                {price != null && <p className="font-display text-2xl font-bold" data-testid="experience-price">
                    {pct > 0 && <span className="mr-3 text-base text-dim line-through">{money(tour.price)}</span>}
                    {money(price)} <span className="text-xs font-normal text-dim">{PRICING[tour.booking_mode] || ""}</span>
                    {pct > 0 && <span className="ml-3 rounded-full bg-neon-cyan/15 px-3 py-1 text-xs text-neon-cyan">Economize {pct}%</span>}
                </p>}
                <div className="flex flex-wrap gap-4 text-xs text-dim">
                    {tour.duration && <span>Duração: {tour.duration}</span>}
                    {tour.capacity && <span>Capacidade: {tour.capacity} pessoa(s)</span>}
                    {tour.meeting_point && <span>Embarque: {tour.meeting_point}</span>}
                </div>
                <Block title="Roteiro e pontos visitados" text={tour.itinerary} />
                <Block title="O que está incluído" text={tour.included} />
                <Block title="Segurança e requisitos" text={tour.safety_info} />
                <Block title="Observações" text={tour.notes} />
            </div>
        </section>
    );
}
